import { useEffect, useState } from "react";
import { useColorScheme } from "../hooks/useColorScheme";
import styles from "./ComingSoon.module.css";

const TICKER = [
  "Initialising systems…",
  "Calibrating routes…",
  "Compiling experience…",
  "Almost there…",
];

export default function ComingSoon() {
  const scheme = useColorScheme();
  const logo = scheme === "dark" ? "/logo-color.png" : "/logo-color.png";

  const [lineIndex, setLineIndex] = useState(0);
  const [dots, setDots] = useState("");

  useEffect(() => {
    const t = setInterval(
      () => setLineIndex((i) => (i + 1) % TICKER.length),
      2200
    );
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setInterval(
      () => setDots((d) => (d.length >= 3 ? "" : d + ".")),
      420
    );
    return () => clearInterval(t);
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.gridOverlay} />
      <span className={`${styles.corner} ${styles.tl}`} />
      <span className={`${styles.corner} ${styles.tr}`} />
      <span className={`${styles.corner} ${styles.bl}`} />
      <span className={`${styles.corner} ${styles.br}`} />

      <div className={styles.center}>
        <div className={styles.logoWrap}>
          <div className={styles.logoRing} />
          <img src={logo} alt="MyGradeCard" className={styles.logo} />
        </div>

        <div className={styles.badge}>mygradecard.com</div>

        <h1 className={styles.headline}>
          Something&nbsp;<em>great</em>
          <br />
          is coming.
        </h1>

        <p className={styles.sub}>
          We're building something worth waiting for.
          <br />
          Check back soon.
        </p>

        <div className={styles.ticker}>
          <span className={styles.tickDot} />
          <span className={styles.tickText}>
            {TICKER[lineIndex]}
            {dots}
          </span>
        </div>

        <div className={styles.barWrap}>
          <div className={styles.bar} />
        </div>
      </div>
    </div>
  );
}
